import { useMutation } from "@apollo/client";
import type {
  JoinOrganizationByInviteTokenPayload,
  JoinOrganizationByInviteTokenInput,
} from "@casey/db-types";
import { JOIN_ORGANIZATION_BY_INVITE_MUTATION } from "../gql/index";

export function useJoinOrganizationByInvite() {
  return useMutation<
    { joinOrganizationByInviteToken: JoinOrganizationByInviteTokenPayload },
    JoinOrganizationByInviteTokenInput
  >(JOIN_ORGANIZATION_BY_INVITE_MUTATION);
}
